import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a8269ddbedae70014207988_1787017721548_f51c2ad6/consultadiploma/src/app/not-found.tsx");
